import { MIN_PASSWORD_LENGTH } from './authUtils'

export function formatNamePart (name: string | null): string | null {
  if (!name) { return null }
  return name.charAt(0).toUpperCase() + name.slice(1)
}

export function formatFullName (firstName: string | null, lastName: string | null): string | null {
  return `${formatNamePart(firstName) ?? ''} ${formatNamePart(lastName) ?? ''}`.trim()
}

export function stripSpecialCharacters (str: string): string {
  return str.replace(/[^a-zA-Z0-9 ]/g, '').trim()
}

export function isPasswordInvalid (password: string): string | null {
  let errorText = ''
  if (!password.match(/[a-z]/)) {
    errorText += 'Must have at least one lower case character \n'
  }

  if (!password.match(/[A-Z]/)) {
    errorText += 'Must have at least one upper case character \n'
  }

  if (!password.match(/\d/)) {
    errorText += 'Must have at least one numeric character \n'
  }

  if (!password.match(/[^a-zA-Z\d]/)) {
    errorText += 'Must have at least one special character \n'
  }
  if (password.length < MIN_PASSWORD_LENGTH) {
    errorText += 'Must be at least 8 characters long \n'
  }

  if (errorText.length > 0) {
    return errorText
  }

  return null
}
